import { vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40490781")

_pushScopeId("data-v-40490781")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "slider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("label", {
    class: "switch",
    for: 'toggleSwitch' + _ctx.id
  }, [
    _withDirectives(_createVNode("input", {
      type: "checkbox",
      tabindex: "-1",
      id: 'toggleSwitch' + _ctx.id,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue = $event))
    }, null, 8, ["id"]), [
      [_vModelCheckbox, _ctx.localValue]
    ]),
    _hoisted_1,
    (_ctx.localValue && _ctx.activeText)
      ? (_openBlock(), _createBlock("span", {
          key: 0,
          class: "fev_text5 fw_700 text active",
          innerHTML: _ctx.activeText
        }, null, 8, ["innerHTML"]))
      : _createCommentVNode("", true),
    (!_ctx.localValue && _ctx.inactiveText)
      ? (_openBlock(), _createBlock("span", {
          key: 1,
          class: "fev_text5 fw_700 text inactive",
          innerHTML: _ctx.inactiveText
        }, null, 8, ["innerHTML"]))
      : _createCommentVNode("", true)
  ], 8, ["for"]))
})